import { render, staticRenderFns } from "./activity-card-v2.vue?vue&type=template&id=1d76cbf2&scoped=true&"
import script from "./activity-card-v2.vue?vue&type=script&lang=ts&"
export * from "./activity-card-v2.vue?vue&type=script&lang=ts&"
import style0 from "./activity-card-v2.vue?vue&type=style&index=0&id=1d76cbf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d76cbf2",
  null
  
)

export default component.exports